<template>
  <v-dialog :value="value" max-width="460" persistent @input="onInput">
    <v-card class="save-snapshot-dialog">
      <v-card-title class="px-6">
        <h5 class="primary-color mb-0">Save snapshot</h5>
        <v-spacer />
        <v-btn icon aria-label="Close" :disabled="saving" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-6">
        <p class="body-2 mb-3">
          Freezes the current metrics of <strong>{{ groupName }}</strong> as a point of the series
          toward 70 % / 2 %.
        </p>
        <div
          v-if="summary"
          class="caption grey--text text--darken-1 mb-3 save-snapshot-dialog__summary"
        >
          {{ summary }}
        </div>
        <v-textarea
          v-model="note"
          label="Note"
          rows="2"
          auto-grow
          dense
          outlined
          counter="300"
          maxlength="300"
          hide-details="auto"
          :disabled="saving"
        />
        <v-alert v-if="error" dense text type="error" class="mt-3 mb-0">{{ error }}</v-alert>
      </v-card-text>
      <v-divider />
      <v-card-actions class="px-6 py-3">
        <v-spacer />
        <v-btn text class="cancel-modal" :disabled="saving" @click="close">Cancel</v-btn>
        <v-btn
          class="ok-modal save-snapshot-dialog__save"
          :loading="saving"
          :disabled="groupId == null"
          @click="save"
        >
          Save snapshot
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Manual metrics snapshot of a group (M4 contract 7). Service-free: emits `save` `{ note }` and
 * the parent performs `POST /analysis-groups/:id/snapshots`, driving `saving` / `error` back in.
 */
export default {
  name: 'SaveSnapshotDialog',

  props: {
    value: { type: Boolean, default: false },
    groupId: { type: [Number, String], default: null },
    groupName: { type: String, default: 'this group' },
    /** e.g. 'Group Threshold 60 · 12 videos · 75% / 1.6%' */
    summary: { type: String, default: '' },
    saving: { type: Boolean, default: false },
    error: { type: String, default: '' },
  },

  data() {
    return { note: '' };
  },

  watch: {
    value(open) {
      if (open) this.note = '';
    },
  },

  methods: {
    onInput(open) {
      if (!open) this.close();
    },
    close() {
      if (this.saving) return;
      this.$emit('input', false);
    },
    save() {
      if (this.saving) return;
      this.$emit('save', { note: this.note.trim() });
    },
  },
};
</script>

<style scoped>
.save-snapshot-dialog__summary {
  overflow-wrap: anywhere;
}
</style>
